import {JobEventApiDto, JobFilesDeletedEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import Attachment from "../../attachment/Attachment";
import {default as JobEvent, JobEventTypeEnum} from "./JobEvent";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import moment = require("moment");
import TextUtils from "../../../utils/TextUtils";

export default class JobFilesDeletedEvent extends JobEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} jobId job id.
	 * @param {JobEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber job reference number.
	 * @param data job files deleted files event data
	 */
	constructor(public readonly id: string,
		public readonly jobId: string,
		public readonly type: JobEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: JobFilesDeletedEventData) {
		super(id, jobId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: JobEventApiDto): JobFilesDeletedEvent {
		const data = JobFilesDeletedEventData.fromJson(json.data as JobFilesDeletedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new JobFilesDeletedEvent(json.id,
			json.jobId,
			JobEventTypeEnum.JobFilesDeleted,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.File;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getAttachments(): Attachment[] {
		return this.data.deletedFiles;
	}

	getActivityMessage(): string {
		return `${TextUtils.addSIfPlural("File", this.data.deletedFiles.length)} removed`;
	}
}

export class JobFilesDeletedEventData {
	constructor(public readonly deletedFiles: Attachment[]) {}

	public static fromJson(json: JobFilesDeletedEventDataApiDto): JobFilesDeletedEventData {
		return new JobFilesDeletedEventData(json.deletedFiles.map(Attachment.fromJson));
	}
}
